import { i18n } from '../../i18n/i18n';
import { getMagicLinkRedirectTo } from './getMagicLinkRedirectTo';
import { mapAuthError } from './mapAuthError';
import { supabase } from '../supabase';

export type SendMagicLinkResult = { ok: true } | { ok: false; message: string };

/** Shared OTP send used by the login form and resend action. */
export async function sendMagicLink(email: string): Promise<SendMagicLinkResult> {
  if (!supabase) {
    return { ok: false, message: i18n.t('auth:errors.notConfigured') };
  }

  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: getMagicLinkRedirectTo(),
    },
  });

  if (error) {
    return { ok: false, message: mapAuthError(error) };
  }

  return { ok: true };
}
